/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/article-hero.js":
/*!**********************************************!*\
  !*** ./src/scripts/sections/article-hero.js ***!
  \**********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_article_hero_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/article-hero.scss */ \"./src/styles/sections/article-hero.scss\");\n\n\n//=====================================================================================================================\n\nconst initShare = () => {\n  const pageUrl = encodeURIComponent(document.URL);\n  for (const shareBtn of document.querySelectorAll('[data-social-share-item]')) {\n    let url;\n    shareBtn.addEventListener('click', async () => {\n      if (shareBtn.getAttribute('data-social-share-item') == 'Facebook') {\n        url = \"https://www.facebook.com/sharer.php?u=\" + pageUrl;\n      } else if (shareBtn.getAttribute('data-social-share-item') == 'Instagram') {\n        try {\n          await navigator.clipboard.writeText(decodeURIComponent(pageUrl));\n          alert(window.link_copied_to_clipboard_instagram);\n        } catch (err) {\n          console.error('Copy error: ', err);\n          alert(window.link_copy_error);\n        }\n      } else if (shareBtn.getAttribute('data-social-share-item') == 'Linkedin') {\n        url = \"https://www.linkedin.com/shareArticle?mini=true&url=\" + pageUrl;\n      }\n      if (shareBtn.getAttribute('data-social-share-item') != 'Instagram') {\n        window.open(url);\n      }\n    });\n  }\n};\n\n//=====================================================================================================================\n\ndocument.addEventListener('DOMContentLoaded', () => {\n  initShare();\n});\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/scripts/sections/article-hero.js?\n}");

/***/ }),

/***/ "./src/styles/sections/article-hero.scss":
/*!***********************************************!*\
  !*** ./src/styles/sections/article-hero.scss ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/styles/sections/article-hero.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/article-hero.js");
/******/ 	
/******/ })()
;